import { FunctionComponent } from 'react';

const KakaoIcon: FunctionComponent = () => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='16' fill='#FFE337' />
      <path
        d='M15.6719 10C14.7552 10 13.8906 10.1406 13.0781 10.4219C12.2656 10.7031 11.5573 11.0833 10.9531 11.5625C10.349 12.0417 9.86979 12.6042 9.51562 13.25C9.17188 13.8958 9 14.5833 9 15.3125C9 15.7812 9.07292 16.2344 9.21875 16.6719C9.36458 17.099 9.56771 17.5052 9.82812 17.8906C10.099 18.2656 10.4219 18.6146 10.7969 18.9375C11.1719 19.25 11.5833 19.526 12.0312 19.7656L11.5312 22.375L14.4219 20.5312C14.6198 20.5625 14.8229 20.5885 15.0312 20.6094C15.2396 20.6198 15.4531 20.625 15.6719 20.625C16.5885 20.625 17.4531 20.4896 18.2656 20.2188C19.0781 19.9375 19.7865 19.5573 20.3906 19.0781C20.9948 18.5885 21.4688 18.026 21.8125 17.3906C22.1667 16.7448 22.3438 16.0521 22.3438 15.3125C22.3438 14.5833 22.1667 13.8958 21.8125 13.25C21.4688 12.6042 20.9948 12.0417 20.3906 11.5625C19.7865 11.0833 19.0781 10.7031 18.2656 10.4219C17.4531 10.1406 16.5885 10 15.6719 10Z'
        fill='black'
      />
    </svg>
  );
};

export default KakaoIcon;
